import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import getOut from '../../sounds/ulos.m4a'

import { shufflaa } from '../../utils/randomize'
import { data } from './data/data_01_A_soitettuOvikelloa'
// import kuva from './images/kuva_doorbell_pushed.jpg'
import kuva from './images/pentti_ovella_300x430.png'

const Scene_01_A_SoitettuOvikelloa = ({ scoreHandler, visibilityHandler, soundsOn, enimi, onimi }) => {
    //otetaan vastaan propseista funktiot

    let lista = null


    //Statemjat
    const [teksti, setTeksti] = useState('')
    const [optiot1, setOptiot1] = useState([])
    const [optiot2, setOptiot2] = useState([])
    const [optiot1Populoitu, setOptiot1Populoitu] = useState(false)
    const [optiot2Populoitu, setOptiot2Populoitu] = useState(false)
    const [klikattuOptio, setKlikattuOptio] = useState('')

    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [playGetOut] = useSound(getOut);

    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {
        setOptiot1(data.optiot)
        setOptiot1Populoitu(true)
        setTeksti(data.kysymysteksti)
    }, [])

    // optiot2:een shufflattu järjestys
    useEffect(() => {//
        if (optiot1.length != 0) {
            // console.log(optiot1);
            setOptiot2(shufflaa(optiot1))
        }
    }, [optiot1])

    useEffect(() => {//
        if (optiot2.length != 0) {
            // console.log(optiot1);
            optiot2.forEach(o => {
                o.teksti = o.teksti.replace("(oma nimi)", enimi)
                o.teksti = o.teksti.replace("(ohjaajan nimi)", onimi)
            });
        }
    }, [optiot2])

    const klikattuVaihtoehtoa = (optio) => {

        // if (optio.valinta == 'C_Sinuteltu' && soundsOn) {
        //     playGetOut()
        // }

        if (soundsOn) {

            if (Number(optio.pisteet) > 0) {
                // playCorrectAnswer()
            }
            else {
                // playWrongAnswer()
            }

        }
        scoreHandler(optio, data.scene, data.maxp)
        // scoreHandler(konkatenoiKoonti(optio))
        visibilityHandler(optio.valinta)
    }

    if (optiot2.length != 0) {
        lista = optiot2.map(optio =>
            <li key={optio.id}>
                {/* <img
                    src={getImageSource(optio)}
                    alt={optio.id}
                    onClick={() => klikattuVaihtoehtoa(optio)}
                /> */}
                <span className='clickable'
                    onClick={() => klikattuVaihtoehtoa(optio)}>
                    {optio.teksti}
                </span>
            </li>
        );
    }
    return (


        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>
                <img src={kuva} alt='kuva' />
            </div>

            <div id='question'>

                <h4>{(teksti != null && teksti != "") ? teksti : null}</h4>
            </div>

            <div id='actions'>
                <ul>
                    {lista}
                </ul>
            </div>
        </div>

    )

}

export default Scene_01_A_SoitettuOvikelloa